import useDisplayedAttributes from './useDisplayedAttributes';

export default useDisplayedAttributes;
